import { render } from "./BottomNavigation.vue?vue&type=template&id=67f75eb1"
const script = {}

import exportComponent from "/var/www/html/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__